import {useMemo} from "../../_snowpack/pkg/react.js";
import DOMPurify from "../../_snowpack/pkg/dompurify.js";
const useSanitize = (dangerous) => useMemo(() => DOMPurify.sanitize(dangerous), [dangerous]);
export default useSanitize;
